<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28" height="28" viewBox="0 0 650 591" enable-background="new 0 0 650 591" xml:space="preserve">
<path fill="#2B3B45" opacity="1.000000" stroke="none"
	d="
M118.000000,0.999999
	C174.354233,1.000000 230.708450,1.000000 287.542114,1.378643
	C292.093262,3.383095 296.612000,4.349062 300.157562,6.751371
	C313.951202,16.097271 327.930298,25.284832 340.888184,35.714359
	C352.449402,45.019730 364.674927,49.345097 379.579254,49.187981
	C427.389160,48.683987 475.207733,48.994846 523.022949,49.020687
	C524.999756,49.021759 527.014465,49.126205 528.947205,49.508072
	C545.105225,52.700569 558.757812,60.148075 568.893799,73.405708
	C576.609680,83.497818 581.896912,94.732658 581.920593,107.570366
	C582.075134,191.205093 582.002869,274.840240 581.980835,358.475250
	C581.980347,360.286804 581.867920,362.132996 581.514221,363.904419
	C578.291199,380.047302 570.888428,393.725220 557.624512,403.864746
	C547.386414,411.691223 536.001892,416.899048 522.960022,416.937317
	C471.146759,417.089417 419.332764,416.999725 367.519043,416.999603
	C365.444946,416.999603 363.370850,416.999603 361.041077,416.999603
	C361.041077,430.557068 361.041077,443.206940 360.673035,455.907654
	C350.561462,451.841675 340.748688,447.878571 331.107697,443.534119
	C327.115387,441.735138 323.606720,441.891479 319.701569,443.598816
	C310.312561,447.703674 300.813293,451.556488 291.243103,455.022278
	C291.127686,442.124512 291.127686,429.715424 291.127686,416.999603
	C288.121185,416.999603 286.135559,416.999603 284.149963,416.999603
	C232.489319,416.999725 180.828659,417.004364 129.168015,416.982849
	C127.185730,416.982025 125.162544,416.939606 123.227730,416.561646
	C106.683105,413.330139 92.746834,405.591370 82.560661,391.970703
	C75.189201,382.113831 70.090370,371.063934 70.073837,358.562256
	C69.942039,258.907379 69.999794,159.252243 70.005241,59.597187
	C70.005325,58.099159 69.854927,56.554871 70.152519,55.109974
	C75.504517,29.124411 90.258057,11.349361 115.768448,2.961197
	C116.633705,2.676688 117.261513,1.670043 118.000000,0.999999
M157.637527,260.582825
	C156.797485,259.777191 155.969009,258.285278 155.115631,258.270905
	C145.339127,258.106049 135.558838,258.165924 125.524742,258.165924
	C125.584259,268.512482 129.060532,276.863556 136.128387,283.578705
	C152.998398,299.606842 187.728531,300.655640 205.570297,285.827057
	C219.844345,273.963684 224.949783,247.383026 205.851288,233.776840
	C199.225815,229.056671 191.068924,226.431702 183.497314,223.110077
	C176.668655,220.114410 169.554672,217.749603 162.813156,214.581741
	C158.246185,212.435654 156.807892,208.189423 157.652771,203.217026
	C158.485916,198.313721 161.545624,195.741043 166.249878,194.779373
	C175.260223,192.937408 181.258484,196.842575 184.661316,206.672394
	C195.266998,206.672394 205.807892,206.672394 216.363480,206.672394
	C215.379196,193.169296 210.414993,183.895584 199.744492,177.880295
	C181.649384,167.679535 162.779160,167.498505 144.258560,176.345917
	C130.713562,182.816437 125.053391,194.506409 125.811569,209.474670
	C126.518982,223.440704 134.287613,232.220398 146.421707,237.527390
	C153.242691,240.510605 160.534454,242.399277 167.466461,245.152817
	C172.671555,247.220398 178.084793,249.249710 182.607834,252.430222
	C188.776855,256.768188 188.133484,265.909546 182.071335,269.855713
	C172.935822,275.802490 161.269440,271.718292 157.637527,260.582825
M435.703186,292.394653
	C436.370941,293.261688 437.025055,294.870972 437.708588,294.883545
	C446.825775,295.051392 455.947144,294.995758 465.544128,294.995758
	C465.544128,280.171783 465.544128,265.765656 465.544128,250.932495
	C472.648651,250.932495 479.280853,251.055603 485.906921,250.906418
	C498.995911,250.611755 511.154205,247.365448 520.052490,237.146744
	C530.416443,225.244888 531.654785,211.198120 526.654480,196.821930
	C521.522522,182.067154 509.707764,174.600037 494.866119,173.157516
	C480.996368,171.809448 466.943146,172.322601 452.969543,172.082870
	C447.355286,171.986557 441.738037,172.067001 435.700165,172.067001
	C435.700165,212.199173 435.700165,251.803711 435.703186,292.394653
M316.541840,190.309296
	C316.541840,184.347641 316.541840,178.385986 316.541840,172.395325
	C289.596680,172.395325 263.213379,172.395325 236.687073,172.395325
	C236.687073,213.336914 236.687073,253.942398 236.687073,294.758850
	C246.647461,294.758850 256.378265,294.758850 266.577026,294.758850
	C266.577026,278.248016 266.577026,261.980164 266.577026,245.094421
	C279.245941,245.094421 291.463348,245.094421 303.625977,245.094421
	C303.625977,237.058472 303.625977,229.653870 303.625977,221.900787
	C291.200989,221.900787 279.086578,221.900787 266.896149,221.900787
	C266.896149,213.168243 266.896149,204.797440 266.896149,196.041321
	C283.516571,196.041321 299.787750,196.041321 316.317047,196.041321
	C316.403717,194.195053 316.472687,192.726578 316.541840,190.309296
M347.500122,172.067825
	C340.382507,172.067825 333.264893,172.067825 325.996643,172.067825
	C325.996643,180.292618 325.996643,188.006180 325.996643,196.269928
	C336.831818,196.269928 347.383301,196.269928 358.230530,196.269928
	C358.230530,229.410294 358.230530,261.998718 358.230530,294.722412
	C368.272339,294.722412 377.991211,294.722412 388.183777,294.722412
	C388.183777,261.737061 388.183777,229.029053 388.183777,195.870697
	C399.223175,195.870697 409.792999,195.870697 420.318481,195.870697
	C420.318481,187.694824 420.318481,179.982025 420.318481,172.067841
	C396.118866,172.067841 372.309448,172.067841 347.500122,172.067825
z"/>

<path fill="#2B3B45" opacity="1.000000" stroke="none"
	d="
M396.160309,481.956116
	C472.293304,481.970764 548.426636,482.097260 624.558960,481.877258
	C635.760803,481.844910 643.544434,486.229675 648.932678,495.682343
	C649.234741,496.212402 649.833435,496.573425 650.647034,497.006561
	C651.000000,510.020905 651.000000,523.041809 650.646667,536.522034
	C649.751038,537.565735 649.083069,538.075500 648.685303,538.745667
	C643.355591,547.723999 635.873047,552.136597 625.053894,552.109497
	C544.579956,551.907776 464.105255,552.001953 383.630829,551.990234
	C381.302734,551.989868 378.974670,551.844421 376.743225,551.426636
	C389.714630,529.841492 395.648315,506.656433 396.160309,481.956116
z"/>
<path fill="#2B3B45" opacity="1.000000" stroke="none"
	d="
M0.999996,497.468658
	C2.689436,495.131622 4.511516,493.365448 6.043782,491.376038
	C10.902759,485.067505 17.136473,481.953339 25.201340,481.959991
	C101.441849,482.022919 177.682434,481.991425 254.452042,482.430908
	C255.227737,502.228302 259.265259,520.741882 267.347656,538.343384
	C269.458893,542.941101 271.719025,547.470459 273.447937,552.020386
	C190.399216,552.006287 107.813301,551.974060 25.227468,552.045654
	C17.135038,552.052673 10.927083,548.905212 6.047057,542.624023
	C4.505550,540.639954 2.690086,538.868652 1.000005,537.000000
	C1.000000,523.979126 1.000000,510.958221 0.999996,497.468658
z"/>
<path fill="#FEFEFE" opacity="1.000000" stroke="none"
	d="
M273.910797,552.031250
	C271.719025,547.470459 269.458893,542.941101 267.347656,538.343384
	C259.265259,520.741882 255.227737,502.228302 254.910400,482.415283
	C255.037399,474.405701 258.932281,469.160706 265.562866,466.196320
	C273.830109,462.500214 282.325867,459.315216 291.040741,455.710266
	C300.813293,451.556488 310.312561,447.703674 319.701569,443.598816
	C323.606720,441.891479 327.115387,441.735138 331.107697,443.534119
	C340.748688,447.878571 350.561462,451.841675 360.673035,455.907654
	C370.437134,460.128387 379.980377,464.111206 389.167664,468.792511
	C393.808044,471.157013 395.883453,475.830231 396.086731,481.552124
	C395.648315,506.656433 389.714630,529.841492 376.487854,551.666382
	C375.746674,553.292236 375.575623,554.501038 374.935425,555.360107
	C365.925385,567.450195 355.553467,578.093506 342.506592,585.931580
	C339.530090,587.719788 336.828247,589.965088 334.000000,592.000000
	C328.645081,592.000000 323.290131,592.000000 317.757751,591.694275
	C313.500305,588.871155 309.383270,586.411560 305.347107,583.825684
	C292.489075,575.588013 282.328583,564.667358 273.910797,552.031250
M320.567810,522.086792
	C319.489105,523.473206 318.410400,524.859558 316.898468,526.802734
	C314.586426,524.278625 312.617615,522.055786 310.569214,519.908875
	C306.829346,515.989136 302.890808,515.446960 299.688690,518.342773
	C296.312866,521.395691 296.550018,525.438843 300.486450,529.637512
	C304.010895,533.396790 307.634705,537.063049 311.222931,540.762390
	C316.817505,546.530151 320.478577,546.283997 325.263214,539.697693
	C334.340912,527.201782 343.367340,514.668701 352.414520,502.150665
	C355.988953,497.204926 355.874603,493.078003 352.091400,490.416107
	C348.385315,487.808380 344.729492,488.844574 341.191498,493.677948
	C334.423492,502.923950 327.721497,512.218262 320.567810,522.086792
z"/>
<path fill="#000000" opacity="1.000000" stroke="none"
	d="
M334.468658,592.000000
	C336.828247,589.965088 339.530090,587.719788 342.506592,585.931580
	C355.553467,578.093506 365.925385,567.450195 374.935425,555.360107
	C375.575623,554.501038 375.746674,553.292236 376.391235,552.006348
	C378.974670,551.844421 381.302734,551.989868 383.630829,551.990234
	C464.105255,552.001953 544.579956,551.907776 625.053894,552.109497
	C635.873047,552.136597 643.355591,547.723999 648.685303,538.745667
	C649.083069,538.075500 649.751038,537.565735 650.646667,536.990723
	C651.000000,555.311768 651.000000,573.623474 651.000000,592.000000
	C545.645752,592.000000 440.291534,592.000000 334.468658,592.000000
z"/>
<path fill="#000000" opacity="1.000000" stroke="none"
	d="
M273.447937,552.020386
	C282.328583,564.667358 292.489075,575.588013 305.347107,583.825684
	C309.383270,586.411560 313.500305,588.871155 317.290161,591.694275
	C211.666656,592.000000 106.333298,592.000000 1.000000,592.000000
	C1.000000,573.894775 1.000000,555.916077 1.000005,537.468628
	C2.690086,538.868652 4.505550,540.639954 6.047057,542.624023
	C10.927083,548.905212 17.135038,552.052673 25.227468,552.045654
	C107.813301,551.974060 190.399216,552.006287 273.447937,552.020386
z"/>
<path fill="#FDFDFD" opacity="1.000000" stroke="none"
	d="
M157.727142,260.973755
	C161.269440,271.718292 172.935822,275.802490 182.071335,269.855713
	C188.133484,265.909546 188.776855,256.768188 182.607834,252.430222
	C178.084793,249.249710 172.671555,247.220398 167.466461,245.152817
	C160.534454,242.399277 153.242691,240.510605 146.421707,237.527390
	C134.287613,232.220398 126.518982,223.440704 125.811569,209.474670
	C125.053391,194.506409 130.713562,182.816437 144.258560,176.345917
	C162.779160,167.498505 181.649384,167.679535 199.744492,177.880295
	C210.414993,183.895584 215.379196,193.169296 216.363480,206.672394
	C205.807892,206.672394 195.266998,206.672394 184.661316,206.672394
	C181.258484,196.842575 175.260223,192.937408 166.249878,194.779373
	C161.545624,195.741043 158.485916,198.313721 157.652771,203.217026
	C156.807892,208.189423 158.246185,212.435654 162.813156,214.581741
	C169.554672,217.749603 176.668655,220.114410 183.497314,223.110077
	C191.068924,226.431702 199.225815,229.056671 205.851288,233.776840
	C224.949783,247.383026 219.844345,273.963684 205.570297,285.827057
	C187.728531,300.655640 152.998398,299.606842 136.128387,283.578705
	C129.060532,276.863556 125.584259,268.512482 125.524742,258.165924
	C135.558838,258.165924 145.339127,258.106049 155.115631,258.270905
	C155.969009,258.285278 156.797485,259.777191 157.727142,260.973755
z"/>

<path fill="#303F49" opacity="1.000000" stroke="none"
	d="
M320.779968,521.789673
	C327.721497,512.218262 334.423492,502.923950 341.191498,493.677948
	C344.729492,488.844574 348.385315,487.808380 352.091400,490.416107
	C355.874603,493.078003 355.988953,497.204926 352.414520,502.150665
	C343.367340,514.668701 334.340912,527.201782 325.263214,539.697693
	C320.478577,546.283997 316.817505,546.530151 311.222931,540.762390
	C307.634705,537.063049 304.010895,533.396790 300.486450,529.637512
	C296.550018,525.438843 296.312866,521.395691 299.688690,518.342773
	C302.890808,515.446960 306.829346,515.989136 310.569214,519.908875
	C312.617615,522.055786 314.586426,524.278625 316.898468,526.802734
	C318.410400,524.859558 319.489105,523.473206 320.779968,521.789673
z"/>
<path fill="#31414A" opacity="1.000000" stroke="none"
	d="
M485.466003,226.935989
	C478.707611,226.972931 472.395569,226.972931 465.770752,226.972931
	C465.770752,216.743896 465.770752,206.691025 465.770752,196.269592
	C471.934174,196.269592 477.901642,195.932831 483.816711,196.345901
	C493.491516,197.021530 498.277679,201.743362 498.828827,210.386810
	C499.409241,219.488068 495.435791,224.567596 485.466003,226.935989
z"/>
</svg>
</template>